export function isComplexPluginOutput(obj) {
    return typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, 'content');
}
